/**
 * Arch Hangar Template
 *
 * Semi-cylindrical arch/Quonset-style hangar. Single open unit
 * under a curved shell with flat end walls and optional doors.
 */

import { Tent } from 'lucide-react'
import type { BuildingTemplate } from '../types'
import type { ArchHangarParams } from './params'
import { archHangarParamsSchema, DEFAULT_ARCH_HANGAR_VALUES } from './params'
import { generateBuilding, generateUnits } from './generate'

export const ArchHangarTemplate: BuildingTemplate<ArchHangarParams> = {
  id: 'arch_hangar',
  name: 'Arch Hangar (Quonset)',
  description: 'Semi-cylindrical arch-span building, no internal columns.',
  icon: Tent,
  buildingType: 'arch_hangar',
  generateBuilding,
  generateUnits,
  formSchema: archHangarParamsSchema,
  defaultValues: DEFAULT_ARCH_HANGAR_VALUES,
}

export type { ArchHangarParams, ArchProfile, ArchDoorConfig } from './params'
export {
  archHangarParamsSchema,
  DEFAULT_ARCH_HANGAR_VALUES,
  archDoorToDoorSpec,
  getMaxDoorHeight,
} from './params'
export {
  generateArchProfile,
  calculateTotalHeight,
  getArchHeightAtX,
} from './calculations'
export type { ArchPoint } from './calculations'
